<template>
  <div>
    <div
      style="display: flex; flex-wrap: wrap; justify-content: center !important"
    >
      <div class="content">
        <div>
          <div
            style="
              font-size: 1rem !important;
              font-weight: 700 !important;
              margin-top: 20px;
              margin-bottom: 10px;
            "
          >
            <span style="color: #0067b3">{{ record.code }}</span>
            {{ record.model }} {{ record.brand }}
          </div>
          <div style="display: flex">
            <div style="flex: 5">
              <img
                width="630px"
                height="500px"
                :src="imgs[0] ? imgs[0] : img"
                alt=""
                class="img1"
              />
            </div>
            <div class="rightCard">
              <div
                class="div-row bg-white marginBottom"
                style="padding-top: 15px; padding-bottom: 15px"
              >
                <div class="text-center">
                  <!-- <img width="40px" src="../img/rili.png" alt="" /> -->
                  <div>{{ $t("叉车属具详情.品牌") }}</div>
                  <div>{{ record.brand }}</div>
                </div>

                <div class="text-center">
                  <!-- <img width="40px" src="../img/xiangao.png" alt="" /> -->
                  <div>{{ $t("叉车属具详情.生产年份") }}</div>
                  <div>{{ record.factoryDate }}</div>
                </div>
              </div>
              <div
                v-if="Object.keys(this.$store.state.userInfo).length <= 0"
                style="
                  display: flex;
                  width: 100%;
                  align-items: center;
                  padding-left: 20px;
                  padding-top: 15px;
                  padding-bottom: 15px;
                "
                class="bg-white marginBottom"
              >
                <span style="font-size: 18px">
                  {{ $t("叉车属具详情.登录后查询价格") }}</span
                >
              </div>
              <div
                style="
                  display: flex;
                  width: 100%;
                  align-items: center;
                  padding-left: 20px;
                  padding-top: 15px;
                  padding-bottom: 15px;
                "
                class="bg-grey marginBottom"
              >
                <div style="flex: 5">
                  <div>
                    <span style="font-size: 18px">
                      {{ $t("叉车属具详情.需要帮助请联系") }}</span
                    >
                  </div>
                  <div>
                    <span style="font-size: 18px" class="text-call">
                      +13504428433</span
                    >
                  </div>
                </div>
                <div
                  style="
                    flex: 5;
                    display: flex;
                    justify-content: flex-end;
                    margin-right: 8px;
                  "
                >
                  <a-button
                    size="large"
                    style="background-color: #04af04 !important; color: white"
                    >{{ $t("叉车属具详情.查询") }}</a-button
                  >
                </div>
              </div>
              <div
                class="div-row"
                style="padding-top: 55px; padding-bottom: 15px"
              >
                <!-- <div
                  style="
                    display: flex;
                    justify-content: flex-start;
                    width: 100%;
                    flex-wrap: wrap;
                  "
                >
                  <img width="40px" src="../img/bofang.png" alt="" />
                  <span
                    style="
                      margin-left: 5px;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                    >{{ $t("叉车属具详情.视频") }}</span
                  >
                </div> -->
              </div>
            </div>
          </div>
          <!-- <div style="margin-top: 20px; margin-bottom: 10px">
            <video
              style="width: 16.66666667%"
              controls=""
              preload="auto"
              poster="https://www.chuf.com/?img-webp=fotoch/50735/50735-01.jpg&webp-width=480"
            >
              <source src="https://youtu.be/CT6AWCYPa9I" type="video/mp4" />
            </video>
          </div> -->
          <div style="margin-top: 20px; margin-bottom: 10px">
            <div>
              <div>
                <a-carousel arrows :dots="false" :autoplay="false">
                  <div
                    slot="prevArrow"
                    class="custom-slick-arrow"
                    style="left: 10px; z-index: 1"
                  >
                    <a-icon type="left-circle" />
                  </div>
                  <div
                    slot="nextArrow"
                    class="custom-slick-arrow"
                    style="right: -20px"
                  >
                    <a-icon type="right-circle" />
                  </div>
                  <div v-for="(item, index) in arr" :key="index">
                    <div
                      class="layoutHeaderRs_footIamgs"
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                      "
                    >
                      <img
                        v-for="(it, i) in item"
                        :key="i"
                        :src="it"
                        alt=""
                        class="carouselImg"
                      />
                    </div>
                  </div>
                </a-carousel>
              </div>
            </div>
          </div>

          <div style="margin-top: 40px; margin-bottom: 10px; display: flex">
            <div
              style="
                flex: 0 0 auto;
                width: 33.33333333%;
                margin-left: 20px;
                margin-right: 20px;
              "
            >
              <a-card size="small" style="width: 100%" :bordered="false">
                <a></a>
                <template slot="title"
                  ><a class="CardTitle">{{ $t("叉车属具详情.属具参数") }}</a>
                </template>
                <div class="rowStyle">
                  <span>{{ $t("叉车属具详情.登记号") }}</span
                  ><span style="float: right">{{ record.code }}</span>
                </div>
                <div class="rowStyle">
                  <span>{{ $t("叉车属具详情.品牌") }}</span
                  ><span style="float: right">{{ record.brand }}</span>
                </div>
                <div class="rowStyle">
                  <span>{{ $t("叉车属具详情.规格型号") }}</span
                  ><span style="float: right">{{ record.model }}</span>
                </div>
              </a-card>
            </div>
            <div
              style="
                flex: 0 0 auto;
                width: 33.33333333%;
                margin-left: 20px;
                margin-right: 20px;
              "
            >
              <a-card size="small" style="width: 100%" :bordered="false">
                <a></a>
                <template slot="title"
                  ><a class="CardTitle">{{ $t("叉车属具详情.属具属性") }}</a>
                </template>
                <div class="rowStyle">
                  <span>{{ $t("叉车属具详情.生产年份") }}</span
                  ><span style="float: right">{{ record.factoryDate }}</span>
                </div>
                <div class="rowStyle">
                  <span>{{ $t("叉车属具详情.属具类型") }}</span
                  ><span style="float: right">{{ record.属具类型 }}</span>
                </div>
              </a-card>
            </div>
            <div style="flex: 0 0 auto; width: 16.66666667%"></div>
            <div
              style="
                flex: 0 0 auto;
                width: 16.66666667%;
                margin-left: 20px;
                margin-right: 20px;
              "
            >
              <right-mode></right-mode>
            </div>
          </div>
          <div
            style="
              margin-top: 20px;
              margin-bottom: 10px;
              text-align: center;
              font-size: 30px;
            "
          >
            {{ $t("叉车属具详情.其他属具") }}
          </div>
          <div style="margin-top: 20px; margin-bottom: 10px">
            <div>
              <a-carousel arrows :dots="false" :autoplay="false">
                <div
                  slot="prevArrow"
                  class="custom-slick-arrow"
                  style="left: 10px; z-index: 1"
                >
                  <a-icon type="left-circle" />
                </div>
                <div
                  slot="nextArrow"
                  class="custom-slick-arrow"
                  style="right: -20px"
                >
                  <a-icon type="right-circle" />
                </div>
                <div v-for="(item, index) in listArr" :key="index">
                  <div>
                    <div
                      class="layoutfork"
                      style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                      "
                    >
                      <accessoriy-mode
                        v-for="(it, i) in item"
                        :key="i"
                        @getID="getID"
                        class="carouselImg1"
                        :record="it"
                      >
                      </accessoriy-mode>
                    </div>
                  </div>
                </div>
              </a-carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
    <quotationDlg ref="quotationDlg"></quotationDlg>
  </div>
</template>

<script>
import AccessoriyMode from "../model/accessoriyMode.vue";
import RightMode from "../model/rightMode.vue";
import axios from "axios";
import quotationDlg from "../model/quotation";
// import Router from "vue-router";
import { getBucket, arr1To2 } from "../utils/util";
export default {
  components: { AccessoriyMode, RightMode, quotationDlg },
  data() {
    return {
      record: {},
      imgs: [],
      arr: [],
      list: [],
      listArr: [[]],
      img: require("../img/wtupian.png"),
    };
  },
  mounted() {
    const id = this.$route.query.id;
    this.isLogin = Object.keys(this.$store.state.userInfo).length;
    if (id) {
      this.queryData(id);
      this.queryAction();
      window.scrollTo({
        top: 0,
        behavior: "instant", // 可选，设置为 'smooth' 可以平滑滚动
      });
    } else {
      this.$router.push({
        path: "/accessoriyList",
      });
    }
  },
  methods: {
    async getImg(addr, id) {
      this.imgs = await getBucket(addr, id);
      this.arr = arr1To2(this.imgs, 5);
      console.log("arr=======", this.arr);
    },
    getID(id) {
      this.queryData(id);
      this.queryAction();
    },
    share() {
      navigator.clipboard.writeText(window.location.href);
      this.$message.info("网址已复制到您的剪切板!");
    },
    clickQuotation() {
      //if (Object.keys(this.$store.state.userInfo).length != 0) {
      this.$refs.quotationDlg.show({
        type: "forkDetail",
        record: this.record,
        id: this.record.id,
      });
      // } else {
      //   this.$router.push({ path: "/login" });
      // }
    },
    queryAction() {
      axios
        .post(this.$apiUrl + "/api/general/queryAction", {
          actionName: "getAssetReport",
          filters: {
            queryFilter: [
              {
                dataIndex: "type",
                operator: "eq",
                value: "叉车属具",
              },
              {
                dataIndex: "stateMsg",
                operator: "eq",
                value: "在库",
              },
            ],
          },
          orderBy: [
            {
              field: "reportTime",
              order: "desc",
            },
          ],
          offset: 0,
          limit: 20,
        })
        .then((res) => {
          // console.log(res);

          this.list = res.data.data.map((item) => {
            item.assetConfig.split(";").forEach((obj) => {
              const e = obj.split(":");
              item[e[0]] = e[1];
            });
            return {
              ...item,
            };
          });

          this.listArr = arr1To2(this.list, 5);
          console.log("this.listArr=========", this.listArr);
        });
    },
    queryData(id) {
      axios({
        url: this.$apiUrl + "/api/general/querySingle",
        method: "POST",
        data: {
          tableName: "jf_asset_info",
          id: id,
        },
      }).then((res) => {
        //console.log("res.data=======", res.data);
        // console.log("res.data=======", res.data);

        res.data.data.assetConfig.split(";").forEach((obj) => {
          const e = obj.split(":");
          res.data.data[e[0]] = e[1];
        });
        this.record = res.data.data;
        console.log("res.data.data.id=======", res.data.data.id);
        this.getImg("basic/", res.data.data.id);
      });
    },
  },
};
</script>

<style scoped>
.r1-svg {
  width: 2.5rem !important;
  color: white !important;
  fill: white !important;
}
.r1-span {
  font-size: 2.5rem !important;
  margin-right: 1rem !important;
}
.r2-div {
  font-size: 20px;
  text-align: center;
  margin-top: 3rem !important;
  background: #04af04 !important;
  color: white !important;
  font-weight: 700 !important;
}
.r1-1-Btn {
  margin-top: 20px;
  font-size: 1.25rem;
  padding: 1rem 0.5rem;
  width: 100%;
  height: auto;
}
.r1-1-div {
  color: #ff890a !important;
  padding-right: 0.5rem !important;
  margin-bottom: 1rem !important;
  margin-top: 1rem !important;
}
.r1-div {
  font-size: 18px;
  font-weight: 700 !important;
  text-align: center;
  padding: 3rem !important;
  border: 1px solid black;
}
.layoutfork {
  flex: 2.5;
  height: auto;
  margin-left: 1.2rem;
  margin-bottom: 1.5rem;
  cursor: pointer;
}
.CardTitle {
  color: #0067b3;
  font-size: 20px;
  padding-bottom: 12px;
}
.rowStyle {
  border-bottom: 1px solid #f2f3f3;
  padding-top: 10px;
  padding-right: 5px;
  padding-left: 5px;
  padding-bottom: 10px;
}
.ant-carousel .slick-next::before {
  content: "";
}
.ant-carousel .slick-prev::before {
  content: "";
}
.ant-carousel >>> .slick-slide {
  text-align: center;
  height: auto;
  line-height: auto;
}

.ant-carousel >>> .custom-slick-arrow {
  width: 55px;
  height: 55px;
  font-size: 50px;
  color: #ececec;
}
.ant-carousel >>> .custom-slick-arrow:hover {
  opacity: 0.5;
  color: #0067b3;
}
.carouselImg {
  width: 18%;
  height: auto;
}
.carouselImg1 {
  width: 100%;
  height: 100%;
}
.img1 {
  object-fit: cover; /* 不会变形，但可能裁剪图片 */
}

.layoutHeaderRs_footIamgs {
  width: 10rem;
  height: 10rem;
  margin-left: 1.2rem;
  margin-bottom: 1.5rem;
  cursor: pointer;
}

.layoutFootBottoms {
  width: 100vw;
  position: fixed;
  bottom: 0;
}

.text-call {
  color: #04af04 !important;
  font-size: 2rem !important;
}
.content {
  width: 83.33333333%;
}
.a-top {
  color: #0067b3 !important;
  margin-right: 8px;
}
.rightCard {
  background-color: #f2f3f3;
  padding: 3rem !important;
  flex: 5;
}
.div-row {
  display: flex;
  justify-content: space-around;
  width: 100%;
  flex-wrap: wrap;
}
.text-center {
  text-align: center !important;
}
.bg-white {
  background: white !important;
}
.bg-grey {
  background: #ececec !important;
}
.marginBottom {
  margin-bottom: 20px;
}
</style>
